<template>
  <div class="p-4">
    <slot />
  </div>
</template>
